import { useState, useRef } from "react";
import "./editorialForms.css";

const mealTypes = [
  { id: "breakfast", name: "Café da Manhã" },
  { id: "lunch", name: "Almoço" },
  { id: "dinner", name: "Jantar" },
  { id: "snack", name: "Lanche" },
  { id: "dessert", name: "Sobremesa" },
  { id: "drink", name: "Bebida" },
];

const difficulties = [
  { id: "easy", name: "Fácil" },
  { id: "medium", name: "Médio" },
  { id: "hard", name: "Difícil" },
];

export default function RecipeForm({ data, onChange }) {
  const [ingredientInput, setIngredientInput] = useState({
    name: "",
    quantity: "",
    unit: "",
  });
  const [stepInput, setStepInput] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      const filePromises = files.map(file => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            resolve({ file, preview: reader.result, name: file.name });
          };
          reader.readAsDataURL(file);
        });
      });
      
      Promise.all(filePromises).then(results => {
        onChange({ 
          ...data, 
          recipeImages: [...(data?.recipeImages || []), ...results]
        });
      });
    }
  };

  const handleAddIngredient = () => {
    if (ingredientInput.name.trim()) {
      onChange({
        ...data,
        ingredients: [
          ...(data?.ingredients || []),
          {
            name: ingredientInput.name.trim(),
            quantity: ingredientInput.quantity,
            unit: ingredientInput.unit,
            optional: false,
          },
        ],
      });
      setIngredientInput({ name: "", quantity: "", unit: "" });
    }
  };

  const handleRemoveIngredient = (index) => {
    onChange({
      ...data,
      ingredients: (data?.ingredients || []).filter((_, i) => i !== index),
    });
  };

  const handleAddStep = () => {
    if (stepInput.trim()) {
      const currentSteps = data?.instructions || [];
      onChange({
        ...data,
        instructions: [
          ...currentSteps,
          {
            step: currentSteps.length + 1,
            description: stepInput.trim(),
          },
        ],
      });
      setStepInput("");
    }
  };

  const handleRemoveStep = (index) => {
    const newSteps = (data?.instructions || [])
      .filter((_, i) => i !== index)
      .map((step, i) => ({ ...step, step: i + 1 }));
    onChange({ ...data, instructions: newSteps });
  };

  return (
    <div className="editorial_form recipe_form">
      <div className="editorial_form_section">
        <label>
          Nome da Receita <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Bolo de Chocolate Fofinho"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Uma breve descrição da receita..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={2}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Refeição</label>
          <select
            value={data?.mealType || ""}
            onChange={(e) => onChange({ ...data, mealType: e.target.value })}
          >
            <option value="">Selecione</option>
            {mealTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Cozinha</label>
          <input
            type="text"
            placeholder="Ex: Brasileira, Italiana..."
            value={data?.cuisine || ""}
            onChange={(e) => onChange({ ...data, cuisine: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Dificuldade</label>
          <select
            value={data?.difficulty || ""}
            onChange={(e) => onChange({ ...data, difficulty: e.target.value })}
          >
            <option value="">Selecione</option>
            {difficulties.map((diff) => (
              <option key={diff.id} value={diff.id}>
                {diff.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tempo de Preparo (min)</label>
          <input
            type="number"
            placeholder="15"
            value={data?.prepTime || ""}
            onChange={(e) =>
              onChange({ ...data, prepTime: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Tempo de Cozimento (min)</label>
          <input
            type="number"
            placeholder="30"
            value={data?.cookTime || ""}
            onChange={(e) =>
              onChange({ ...data, cookTime: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Porções</label>
          <input
            type="number"
            placeholder="4"
            value={data?.servings || ""}
            onChange={(e) =>
              onChange({ ...data, servings: parseInt(e.target.value) || 0 })
            }
            min="1"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Ingredientes <span className="required">*</span>
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddIngredient}
          >
            + Adicionar
          </button>
        </label>
        <div className="editorial_form_row" style={{ marginBottom: "8px" }}>
          <input
            type="text"
            placeholder="Qtd"
            value={ingredientInput.quantity}
            onChange={(e) =>
              setIngredientInput({ ...ingredientInput, quantity: e.target.value })
            }
            style={{ flex: 1 }}
          />
          <input
            type="text"
            placeholder="Unid"
            value={ingredientInput.unit}
            onChange={(e) =>
              setIngredientInput({ ...ingredientInput, unit: e.target.value })
            }
            style={{ flex: 1 }}
          />
          <input
            type="text"
            placeholder="Ingrediente"
            value={ingredientInput.name}
            onChange={(e) =>
              setIngredientInput({ ...ingredientInput, name: e.target.value })
            }
            style={{ flex: 3 }}
            onKeyPress={(e) => e.key === "Enter" && handleAddIngredient()}
          />
        </div>
        {(data?.ingredients || []).length > 0 && (
          <div className="genre_chips">
            {data.ingredients.map((ing, i) => (
              <span
                key={i}
                className="genre_chip selected"
                onClick={() => handleRemoveIngredient(i)}
                style={{ cursor: "pointer" }}
              >
                {ing.quantity} {ing.unit} {ing.name} ×
              </span>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>
          Modo de Preparo <span className="required">*</span>
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddStep}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Descreva o passo..."
          value={stepInput}
          onChange={(e) => setStepInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddStep()}
        />
        {(data?.instructions || []).length > 0 && (
          <div style={{ marginTop: "8px" }}>
            {data.instructions.map((step, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "8px",
                  padding: "8px",
                  background: "var(--bg-third)",
                  borderRadius: "6px",
                  marginBottom: "4px",
                }}
              >
                <span
                  style={{
                    background: "var(--blue-color)",
                    color: "white",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    fontSize: "12px",
                  }}
                >
                  {step.step}
                </span>
                <span style={{ flex: 1 }}>{step.description}</span>
                <button
                  type="button"
                  className="remove_variant_btn"
                  onClick={() => handleRemoveStep(i)}
                >
                  ×
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="editorial_form_section">
        <label>Informações Nutricionais (por porção)</label>
        <div className="editorial_form_row">
          <input
            type="number"
            placeholder="Calorias"
            value={data?.nutrition?.calories || ""}
            onChange={(e) =>
              onChange({
                ...data,
                nutrition: {
                  ...data?.nutrition,
                  calories: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
          <input
            type="number"
            placeholder="Proteína (g)"
            value={data?.nutrition?.protein || ""}
            onChange={(e) =>
              onChange({
                ...data,
                nutrition: {
                  ...data?.nutrition,
                  protein: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
          <input
            type="number"
            placeholder="Carbs (g)"
            value={data?.nutrition?.carbs || ""}
            onChange={(e) =>
              onChange({
                ...data,
                nutrition: {
                  ...data?.nutrition,
                  carbs: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
          <input
            type="number"
            placeholder="Gordura (g)"
            value={data?.nutrition?.fat || ""}
            onChange={(e) =>
              onChange({
                ...data,
                nutrition: {
                  ...data?.nutrition,
                  fat: parseInt(e.target.value) || 0,
                },
              })
            }
            min="0"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isVegetarian"
              checked={data?.isVegetarian || false}
              onChange={(e) =>
                onChange({ ...data, isVegetarian: e.target.checked })
              }
            />
            <label htmlFor="isVegetarian">Vegetariana</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isVegan"
              checked={data?.isVegan || false}
              onChange={(e) => onChange({ ...data, isVegan: e.target.checked })}
            />
            <label htmlFor="isVegan">Vegana</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="isGlutenFree"
              checked={data?.isGlutenFree || false}
              onChange={(e) =>
                onChange({ ...data, isGlutenFree: e.target.checked })
              }
            />
            <label htmlFor="isGlutenFree">Sem Glúten</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z" />
        </svg>
        <span>
          Fotos do prato finalizado aumentam muito o engajamento!
        </span>
      </div>
    </div>
  );
}
